import { createAction, props } from '@ngrx/store';

import { Break } from 'app/features/manual-input-registration/models';
import { Activity } from 'app/shared/features/activity-selector/models';

export const initializingBreakStore = createAction('[Break] Initializing');

export const breakStarting = createAction('[Break] Starting', props<{ activity: Activity }>());

export const breakStarted = createAction('[Break] Started', props<{ breakData: Break }>());

export const breakEnding = createAction('[Break] Ending', props<{ endTimestamp: number }>());

export const breakCancelled = createAction('[Break] Cancelled');

export const breakEnded = createAction('[Break] Ended', props<{ breakData: Break; endTimestamp: number }>());

export const activatingBreakDialog = createAction('[Break] Activating Dialog');

export const deactivatingBreakDialog = createAction('[Break] Deactivating Dialog');

export const applyingBreakDataFromStorage = createAction(
    '[Break] Applying Data From Storage',
    props<{
        breakDataFromStorage: Break | undefined;
    }>(),
);
